import { URLS } from "../config";
import { logoutHandler } from "./logoutHandler";
import { Dispatch } from "@reduxjs/toolkit";
import { NavigateFunction } from "react-router-dom";

export const getDiscountList = async (
  params: { limit: number; offset: number },
  token: string,
  dispatch: Dispatch,
  navigate: NavigateFunction
) => {
  const query = new URLSearchParams(params as any).toString();
  const url = `${URLS.GET_PROMOCODES}?${query}`;

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `JWT ${token}`,
    },
  });

  if (response.status === 401) {
    logoutHandler(dispatch, navigate); // خروج از سیستم و ریدایرکت به login
    return;
  }

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || 'خطا در دریافت کدها');
  }

  return await response.json(); // باید شامل لیست کدهای تخفیف باشه
};